export { JsonRpcError, JsonRpcErrorCode } from '../ms_front_lib/utils/jsonrpc_client';


export class Core {

    m_handlers = {};

    on(message, callback) {
        this.m_handlers[message] = callback;
    }

    trigger(message, params) {
        const callback = this.m_handlers[message];
        if (callback) {
            callback(params);
        }
    }

    call_core(method, params = {}) {
        if (gl_mobile_app) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: method,
                data: params
            }));
        }
    }

    quit() {
        this.call_core('front_quit_app');
    }

    loaded() {
        this.call_core('front_loaded');
    }

    open_external_url(iUrl) {
        if (gl_mobile_app) {
            this.call_core('front_launch_url', {url : iUrl});
        } else {
            window.open(iUrl, '_blank').focus();
        }
    }

    share_url(iUrl, iLabel) {
        this.call_core('front_share_url', {url : iUrl, label : iLabel});
    }
}
